import React from 'react';
import { Paper, Box, Skeleton, Grid } from '@mui/material';

export default function LastScrapeSummarySkeleton({ sx = {} }) {
  return (
    <Paper sx={{ p: 3, ...sx }}>
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={180} height={28} />
      </Box>
      <Grid container spacing={2}>
        {[...Array(3)].map((_, i) => (
          <Grid key={i} size={{ xs: 12, sm: 4 }}>
            <Skeleton variant="rectangular" width="100%" height={80} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
